import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-281aeb27")

_pushScopeId("data-v-281aeb27")
const _hoisted_1 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listSize, (v, idx) => {
      return (_openBlock(), _createBlock("div", {
        key: idx,
        class: {'item--selected': _ctx.selectedMap[idx] === true, 'item': true}
      }, [
        _renderSlot(_ctx.$slots, "default", { index: idx }, undefined, true)
      ], 2))
    }), 128))
  ]))
})